import { render, staticRenderFns } from "./WideNscItem.vue?vue&type=template&id=1f1784dd&scoped=true&"
import script from "./WideNscItem.vue?vue&type=script&lang=js&"
export * from "./WideNscItem.vue?vue&type=script&lang=js&"
import style0 from "./WideNscItem.vue?vue&type=style&index=0&id=1f1784dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1784dd",
  null
  
)

export default component.exports